import styled from "styled-components";

export const LauncherDiv = styled.div`
  width: auto;
  height: 99.65vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &::-webkit-scrollbar {
    width: 2px;
    border-radius: 3px;
    background-color: #00000020;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #000000ce;
    width: 2px;
    border-radius: 3px;
  }
`;

export const ProjectLogo = styled.div`
  width: auto;
  height: auto;
  padding: 10px;
`;

export const TextProject = styled.div`
  width: auto;
  height: auto;
  position: absolute;
  bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  h2 {
    font-size: 35px;
    margin: auto;
    line-height: auto;
  }
`;

export const Gradient = styled.div`
  width: 700px;
  height: 500px;
  border: 1px solid black;
  position: absolute;
  border-radius: 428.401px;
  background: linear-gradient(
    180deg,
    #f66bbe 0%,
    rgba(246, 185, 93, 0.541) 100%
  );
  filter: blur(100px);

  @media (max-width: 728px) {
    width: 300px;
    height: 230px;
  }
`;
